<div
  (click)="onLayoutClick()"
  [ngClass]="{
    'layout-static-inactive': staticMenuDesktopInactive,
    'layout-mobile-active': staticMenuMobileActive,
    'layout-overlay-active': overlayMenuActive,
  }"
  class="layout-wrapper layout-static">
  <app-topbar></app-topbar>
  <div (click)="onMenuClick()" class="layout-menu-container">
    <p-scrollPanel [style]="{ height: '100%' }" #layoutMenuScroller>
      <div class="layout-menu-content">
        <app-menu></app-menu>
        <div class="flex flex-col gap-6 pl-6 pr-6 pb-6">
          <img alt="by Rodix" class="flex-1" src="assets/logo/by_rodix.svg" />
          <img alt="swiss made software" class="flex-1" src="assets/logo/swissmade.svg" />
        </div>
      </div>
    </p-scrollPanel>
  </div>

  <div class="layout-content">
    <div class="progress-bar">
      @if (loading) {
        <p-progressBar
          [style]="{ 'background-color': 'transparent', height: '5px' }"
          mode="indeterminate"></p-progressBar>
      }
    </div>
    <app-breadcrumb></app-breadcrumb>

    <div class="layout-content-container">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>

    @if (staticMenuMobileActive) {
      <div class="layout-mask"></div>
    }
  </div>
</div>

<p-toast></p-toast>
<p-toast (onClose)="onDeletionToastClose($event)" key="deletion"></p-toast>
<p-confirmDialog></p-confirmDialog>
